import { useTheme } from '@shopify/restyle';

import { Column } from './box';
import { Button } from './button';
import { Confirm } from '../icons/confirm';
import type { Theme } from 'app/shopify';

interface CheckboxProps {
  checked?: boolean;
  onPress?: () => void;
  color?: keyof Theme['colors'];
  borderRadius?: keyof Theme['borderRadii'];
  testID?: string;
}

export function Checkbox({ checked, onPress, color, borderRadius, testID }: CheckboxProps) {
  const theme = useTheme<Theme>();

  return (
    <Button
      {...{ onPress }}
      alignItems="center"
      testID={testID}
      aspectRatio={1}
      flexShrink={0}
      height={24}
      hitSlop={{ top: 12, bottom: 12, left: 12, right: 12 }}
      justifyContent="center"
      style={{
        borderColor: checked ? theme.colors['surface.brand.default'] : theme.colors['text.tertiary'],
        borderRadius: theme.borderRadii[borderRadius ?? 'radius.sm'],
        borderWidth: 1,
      }}
      variant="plain"
    >
      {checked ? (
        <Column
          alignItems="center"
          aspectRatio={1}
          backgroundColor={color ?? 'surface.brand.default'}
          borderRadius={borderRadius ?? 'radius.sm'}
          height={24}
          justifyContent="center"
        >
          <Confirm color="white" />
        </Column>
      ) : null}
    </Button>
  );
}
